enum ApiEndPoints {
    addAboutUs = "/contactus",
    signUp = "/signup",
    dealer = "/dealer",
    initiateOTP = "/initiateotp",
    validateOTP = "/validateotp",
    roleManagement = "/rolemanagement",
    administrator = "/administrator",
    getRoles = "/roles",
    user = "/user",
    chat = "/chat",
    inventory = "/inventory",
    listFilterInventory = "/filter",
    bid = "/bid",
    productsList = "/productlist",
    dashboard = "/dashboard",
    viewProduct = "/viewproduct",
    masterInventory = "/masterinventory",
    myGarage = "/mygarage",
    reachOut = "/reachout",
    buyFigure = "/buyfigure",
    quote = "/quote",
    privateNetworks = "/privatenetworks",
    chromeData = "/api/vehicle",
    upload = "/upload"
}

export default ApiEndPoints;
